// ==============================|| THEME CONSTANT ||============================== //

export const APP_DEFAULT_PATH = '/dashboard/default';
export const DRAWER_WIDTH = 260;
export const MINI_DRAWER_WIDTH = 60;
export const API_URL = import.meta.env.VITE_API_URL || 'https://api.asistencia360.co/v1';

const config = {
  fontFamily: `'Public Sans', sans-serif`
};

export default config;
